import type { IPlatformAdapter } from '../ports/IPlatformAdapter'
import type { PlatformLaunchPayload } from '../ports/types'
import { PLATFORM_ADAPTER, PLATFORM_PAYLOAD } from '../tokens'

/**
 * Public facade for the Platform module.
 * Prefer this over importing adapters or SDKs from pages.
 */
export function usePlatform() {
  const nuxtApp = useNuxtApp()
  const alt = useAlt()

  return {
    get adapter(): IPlatformAdapter {
      return (nuxtApp.$platform as IPlatformAdapter | undefined)
        ?? alt.get<IPlatformAdapter>(PLATFORM_ADAPTER)
    },
    get payload(): PlatformLaunchPayload {
      return (nuxtApp.$platformPayload as PlatformLaunchPayload | undefined)
        ?? alt.get<PlatformLaunchPayload>(PLATFORM_PAYLOAD)
    },
    get kind() {
      return this.adapter.kind
    },
  }
}
